var SENTRY_RELEASE;SENTRY_RELEASE={name: "Broken Shepherds", version: "1.0.19"};